var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settings.interval)?_c('div',[_vm._v("für "),_c('b',[_c('span',[_vm._v(" "+_vm._s(_vm.settings.interval)+" ")]),_vm._v(" Woche"),(_vm.settings.interval > 1)?[_vm._v("n")]:_vm._e()],2),_vm._v(" gemäss Versorgungsplan ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }